import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import {
  EdiDataItem,
  EdiDataParams,
  EdiDetailsParams,
  PutEdiDetailsParams,
} from "./models";

export const ediApi = createApi({
  baseQuery,
  reducerPath: "ediApi",
  tagTypes: ["edi"],
  endpoints: (builder) => ({
    getEdiData: builder.query<EdiDataItem[], EdiDataParams>({
      query: (body) => ({
        url: "/api/v1/edi_incoming/",
        method: "GET",
        params: body,
      }),
      providesTags: ["edi"],
    }),

    getEdiDetails: builder.query<EdiDataItem, EdiDetailsParams>({
      query: (body) => ({
        url: `/api/v1/edi_incoming/${body.id}`,
        method: "GET",
        params: body,
      }),
      providesTags: ["edi"],
    }),

    putEdiDetails: builder.mutation<EdiDataItem, PutEdiDetailsParams>({
      query: (body) => ({
        url: `/api/v1/edi_incoming/${body.id}`,
        method: "PUT",
        body,
      }),
    }),

    patchEdiDetails: builder.mutation<
      EdiDataItem,
      { id: number; company: number }
    >({
      query: (body) => ({
        url: `/api/v1/edi_incoming/${body.id}`,
        method: "PATCH",
        body,
      }),
    }),

    deleteEdiDetails: builder.mutation<EdiDataItem, { id: number }>({
      query: (body) => ({
        url: `/api/v1/edi_incoming/${body.id}`,
        method: "DELETE",
        body,
      }),
    }),

    uploadEdiFile: builder.mutation<
      void,
      { file: File; format?: "json" | "xml" }
    >({
      query: ({ file, format }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: "/api/v1/edi_incoming/upload_create/",
          method: "POST",
          body: formData,
          params: { format },
        };
      },
      invalidatesTags: ["edi"],
    }),
  }),
});

export const {
  useGetEdiDataQuery,
  useGetEdiDetailsQuery,
  usePutEdiDetailsMutation,
  usePatchEdiDetailsMutation,
  useUploadEdiFileMutation,
  useDeleteEdiDetailsMutation,
} = ediApi;
